import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/home/logo-light.png'
import _imports_1 from '@/assets/images/home/more-icon.png'
import _imports_2 from '@/assets/images/show-list.png'
import _imports_3 from '@/assets/images/home/prev-icon.png'


const _hoisted_1 = { class: "header-box" }
const _hoisted_2 = ["onClick"]

import { ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {

const router = useRouter()
const routerList = [
  {
    title: '混空Studio',
    url: '/studio'
  },
  {
    title: '混空VPS',
    url: '/vps'
  },
  {
    title: '通用解决方案',
    url: '/solution2'
  },
  {
    title: '行业解决方案',
    url: '/solution'
  },
  {
    title: '关于我们',
    url: '/about-us'
  },
  {
    title: '合作咨询',
    url: '/counselling'
  }
]
const showList = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(router).push('/'); showList.value = false})
      }),
      (!showList.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showList.value = true))
          }))
        : _createCommentVNode("", true),
      (showList.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _imports_2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showList.value = false))
          }))
        : _createCommentVNode("", true)
    ]),
    (showList.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "header-box-list",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showList.value = false))
        }, [
          _createElementVNode("div", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routerList, (item, index) => {
              return _createElementVNode("div", {
                key: index,
                onClick: ($event: any) => (_unref(router).push(item.url))
              }, [
                _createElementVNode("span", null, _toDisplayString(item.title), 1),
                _cache[4] || (_cache[4] = _createElementVNode("img", { src: _imports_3 }, null, -1))
              ], 8, _hoisted_2)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})